/* 
 * DELETE THIS SCRIPT TO REMOVE THE SIMULATOR 
 *  
 * Description: This script provides a frontend simulation for demo and testing purposes.
 * 
 * How to use: 
 * - To start the simulation, call the simulatorVersionInfo function first.
 * 
 */

import * as PIXI from 'pixi.js'
import { pixiApp } from './initializePixi'
import { gameData } from './data';

const version = '1.0.0'
export const simulatorVersionInfo = () => {
    // console.info(
    //     "%c CASH-CASH PABUNOT Version: " + gameData.gameVersion,
    //     "color: grey; font-weight: bold; font-size: 16px;"
    // );
    // console.log(
    //     "%c Cash-Cash Pabunot version: " + gameData.gameVersion + " loaded",
    //     "background: green; color: #ffffff"
    // );
    // initializeSimulator()
}

const initializeSimulator = () => {
    const simulatorContainer = new PIXI.Container()
    simulatorContainer.zIndex = 999

    const settingsTex = PIXI.Texture.from('https://static-00.iconduck.com/assets.00/settings-icon-1964x2048-8nigtrtt.png')
    const settingsImg = new PIXI.Sprite(settingsTex)
    settingsImg.anchor.set(0.5)
    if (PIXI.utils.isMobile.any) {
        settingsImg.scale.set(1)
        settingsImg.width = 200
        settingsImg.height = 200
    }
    else {
        settingsImg.scale.set(0.02)
    }
    settingsImg.x = pixiApp.app.screen.width * 0.5
    settingsImg.y = settingsImg.height * 0.7

    simulatorContainer.addChild(settingsImg)
    pixiApp.app.stage.addChild(simulatorContainer)
}
